import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'

import Dialog from '../../components/ReusableComponents/Dialog/index'
import styles from './PmsStatus.module.scss'

const PmsStatus = () => {
  return (
    <div className={styles.container}>
      <Dialog>
        <div className={styles.card}>
          <p className={styles.message}>Attempting to change the password</p>
          <p className={styles.description}>
            This may take in general 2.5 minutes but can take as long as 5 minutes
          </p>
          <LoadingIndicator inline longWaitingTreshold={120} />
        </div>
      </Dialog>
    </div>
  )
}

export default PmsStatus
